var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#127F83",
    d: "M14.667 8a2.42 2.42 0 00-1.262-2.145.139.139 0 01-.067-.16 2.453 2.453 0 00-3.033-3.034.139.139 0 01-.16-.066 2.453 2.453 0 00-4.29 0 .138.138 0 01-.16.066 2.453 2.453 0 00-3.033 3.034.138.138 0 01-.067.16 2.453 2.453 0 000 4.29.14.14 0 01.067.16 2.453 2.453 0 003.033 3.033.14.14 0 01.16.067 2.454 2.454 0 004.29 0 .139.139 0 01.16-.067 2.453 2.453 0 003.033-3.033.14.14 0 01.067-.16A2.419 2.419 0 0014.667 8zm-4.635 3.048a1.016 1.016 0 110-2.033 1.016 1.016 0 010 2.033zm-4.35.055a.556.556 0 01-.783-.784l5.418-5.418a.556.556 0 11.784.784l-5.418 5.418zm.286-6.151a1.016 1.016 0 110 2.032 1.016 1.016 0 010-2.032z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountActive);
export default __webpack_public_path__ + "static/media/discount-active.e8a02ad3ae6e52fae1195c5276a35aed.svg";
export { ForwardRef as ReactComponent };